//status for loading
//combine into one page shared across modules

import React from 'react'
import { StyleSheet } from 'react-native'
import Animated, { FadeInDown } from 'react-native-reanimated'

import * as cth from '@/router/(root)/cth/cthModule'
import { CthAdminControls as AdminControls } from "@/components/Mini/AdminControls"
import { CthBackground as Background } from "@/components/Mini/Background"
import { CthHeader as Header } from "@/components/Mini/Header"
import { CthFooter as Footer } from "@/components/Mini/EntryScreenFooter"
import { CthRules as Rules } from "@/components/Mini/Rules"
import { CthStatBlocks as StatBlocks } from "@/components/Mini/StatBlocks"
import { SecondaryBtn} from "@/components/Mini/Button"

import type { MinigameModule } from '@/types/minigameModule'


export function CthEntryScreen() {
  const { status } = cth.useCthQueryStatus() //keep and use with loading

  const { isAdmin, isSuperAdmin } = cth.useCthUser()

  const gameName = cth.useStore(s => s.GAME_NAME)

  const handleClose = cth.useHandleClose()

  const showAdminControls = isAdmin || isSuperAdmin

  return (
    <Background>
          <Header title={gameName} handler={handleClose} />

          {showAdminControls &&
            <AdminControls />
          }

          <Animated.View entering={FadeInDown.springify()} style={styles.body}>
          
            <Rules />
          
            <StatBlocks />
          
            <LeaderboardBtn />
          
          </Animated.View>

          <Footer />

    </Background>
  )
}

function LeaderboardBtn(){

  const handleLeaderboard = cth.useHandleLeaderboard()
  const theme = cth.useStore(s => s.theme)

  return (
    <SecondaryBtn theme={theme} handler={handleLeaderboard} label="Leaderboard" />
  )
}

const styles = StyleSheet.create({
  fill: { flex: 1 },
  body: { flex: 1, paddingHorizontal: 24, justifyContent: 'center', gap: 40 }
})
